<template>
  <div>
    <data-table ref="dataTable" :option="option"> </data-table>
  </div>
</template>
<script>
import { DataTable } from "@/components/dataTable";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      option: {}
    };
  },
  created() {
    this.option = {
      headSearch: {
        colnum: 1,
        content: [
          {
            label: "关键字",
            name: "KeyWord",
            props: {
              placeholder: "版本号/Id"
            }
          }
        ]
      },
      form: {},
      grid: {
        api: "SystemVersion_List",
        rowKey: "VersionNo",
        columns: [
          {
            title: "序号",
            width: 80,
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "版本号",
            width: "10%",
            dataIndex: "VersionNo"
          },
          {
            title: "创建时间",
            width: "20%",
            dataIndex: "CreateTime"
          },
          {
            title: "更新内容",
            dataIndex: "Description"
          }
        ]
      }
    };
  },
  methods: {
    handleSearch() {
      this.$refs.dataTable.onSearchSubmit();
    }
  }
};
</script>

<style lang="less" scoped>
.text-hide {
  display: inline-block;
  width: calc(100vw - 800px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
